module.exports = __webpack_public_path__ + "images/cyber-monday-promo-banner.png";